export function stringifyDates(state) {
  let stateCopy = JSON.parse(JSON.stringify(state))

  if (state.birthday != null && state.movedIn != null) {
    stateCopy.birthday = stringifyDate(state.birthday)
    stateCopy.movedIn = stringifyDate(state.movedIn)
  }

  if (state.movedIn != null && state.movedOut != null) {
    stateCopy.movedIn = stringifyDate(state.movedIn)
    stateCopy.movedOut = stringifyDate(state.movedOut)
  }

  if (state.birthday != null && state.movedIn != null && state.movedOut != null) {
    stateCopy.birthday = stringifyDate(state.birthday)
    stateCopy.movedIn = stringifyDate(state.movedIn)
    stateCopy.movedOut = stringifyDate(state.movedOut)
  }

  if (state.moveDate != null) {
    stateCopy.moveDate = stringifyDate(state.moveDate)
  }

  if (state.moveOutDate != null) {
    stateCopy.moveOutDate = stringifyDate(state.moveOutDate)
  }

  return stateCopy
}

export function stringifyDate(date) {
  if (date == null) return null
  let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
  let month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date)
  let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date)
  return `${day}.${month}.${year}`
}

export function createDateFromString(date) {
  return new Date(`${date.split('.')[2]}-${date.split('.')[1]}-${date.split('.')[0]}T00:00:00.000`)
}

export function formatDatesInObject(obj) {
  let objCopy = JSON.parse(JSON.stringify(obj))

  if (obj.birthday != null && obj.movedIn != null) {
    objCopy.birthday = createDateFromString(obj.birthday)
    objCopy.movedIn = createDateFromString(obj.movedIn)
  }

  if (obj.movedIn != null && obj.movedOut != null) {
    objCopy.movedIn = createDateFromString(obj.movedIn)
    objCopy.movedOut = createDateFromString(obj.movedOut)
  }

  if (obj.birthday != null && obj.movedIn != null && obj.movedOut != null) {
    objCopy.birthday = createDateFromString(obj.birthday)
    objCopy.movedIn = createDateFromString(obj.movedIn)
    objCopy.movedOut = createDateFromString(obj.movedOut)
  }

  return objCopy
}
